<form [formGroup]="form" class="tab-basdata">
  <div class="row m-3">
    <!-- Kundspecifika krav -->
    <rask-container-block class="col-12">
      <ng-container header>{{texts.headerKundspecifikaKrav}}</ng-container>
      <rask-textarea
        aid="sarskildInfoInput"
        class="col-4"
        [label]="texts.textareaInfoTillMaskinlag"
        [rows]="8"
        [maxlength]="2000"
        formControlName="sarskildInfo">
      </rask-textarea>
    </rask-container-block>

    <!-- Mätningsinstruktion -->
    <rask-container-block class="col-12">
      <ng-container header>{{texts.headerMatningsinstruktion}}</ng-container>

      <div class="row ps-3">
        @if (produktspecifikation.matningsinstruktioner.length > 0) {
          <table class="table col-6 table-margin">
            <thead>
              <tr>
                <th scope="col">{{texts.thLank}}</th>
                <th scope="col">{{texts.thLadesTill}}</th>
                <th scope="col">{{texts.thTaBort}}</th>
              </tr>
            </thead>
            <tbody>
              @for (matningsinstruktion of produktspecifikation.matningsinstruktioner; track matningsinstruktion) {
                <tr>
                  <th class="width30 vertical-align-middle" scope="row"><a href="{{matningsinstruktion.url}}"
                  target="_blank">{{matningsinstruktion.beskrivning}}</a></th>
                  <td class="width60 vertical-align-middle">
                  {{getMatningsinstruktionLadesTill(matningsinstruktion)}}</td>
                  <td class="width10 vertical-align-middle align-text-center">
                    <button
                      id="deleteMatningsinstruktionButton-{{matningsinstruktion.beskrivning}}"
                      [disabled]="!isEditableRole"
                      class="btn btn-icon"
                      type="button"
                      (click)="deleteMatningsinstruktion(matningsinstruktion.id)">
                      <span class="far fa-times"></span>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>

      <div class="row ps-3">
        <rask-input
          aid="matningsinstruktiontextInput"
          [disabled]="!isEditableRole"
          class="col-2"
          [label]="texts.inputLankHeader"
          [maxlength]="200"
          [(ngModel)]="newMatningsintruktiontext"
          [ngModelOptions]="{standalone: true}">
        </rask-input>
        <rask-input
          aid="matningsinstruktionLankInput"
          [disabled]="!isEditableRole"
          class="col-4"
          [label]="texts.inputLankTillMatningsinstruktion"
          [infoText]="texts.infoMatningsinstruktionlank"
          [(ngModel)]="newMatningsinstruktionlank"
          [ngModelOptions]="{standalone: true}"
          [rule]="validation.matningsinstruktionlank">
        </rask-input>
        <rask-button
          aid="addMatningsinstruktionButton"
          class="matningsintruktion-button"
          color="secondary"
          [disabled]="addMatningsinstruktionDisabled"
          (click)="addMatningsinstruktion()">
          {{texts.btnLaggTill}}
        </rask-button>
      </div>
    </rask-container-block>
  </div>

  <!-- Basdata -->
  <div class="row m-3">
    <rask-container-block class="col-12">
      <ng-container header>{{texts.headerBasdata}}</ng-container>

      <!-- Ej Energi -->
      @if (!isEnergi) {
        <div class="row">
          <!-- Diametrar -->
          <div class="col-3">
            <div class="d-flex">
              <rask-input-number
                aid="rotDiaToppMinInput"
                [label]="texts.inputToppDiaMinMax"
                formControlName="diaToppMin"
                [step]="0.1"
                unit="cm"
                [min]="0.1"
                [max]="1000"
                [rule]="validation.diaToppMin">
              </rask-input-number>
              <span>-</span>
              <rask-input-number
                aid="rotDiaToppMaxInput"
                formControlName="diaToppMax"
                [step]="0.1"
                unit="cm"
                [min]="0.1"
                [max]="1000"
                [rule]="validation.diaToppMax">
              </rask-input-number>
            </div>
            <rask-input-number
              aid="rotDiaMaxInput"
              [label]="texts.inputRotDiaMax"
              formControlName="diaRotMax"
              [step]="0.1"
              unit="cm"
              [min]="0.1"
              [max]="1000"
              [rule]="validation.diaRotMax">
            </rask-input-number>
          </div>
          <!-- Längder -->
          <div class="col-9">
            <div class="row">
              <div class="col-4">
                <div class="d-flex">
                  <rask-input-number
                    aid="langdgransMinInput"
                    [label]="texts.inputLangdMinMax"
                    formControlName="langdgransMin"
                    unit="cm"
                    [min]="1"
                    [max]="5000"
                    [rule]="validation.langdgransMin">
                  </rask-input-number>
                  <span>-</span>
                  <rask-input-number
                    aid="langdgransMaxInput"
                    formControlName="langdgransMax"
                    unit="cm"
                    [min]="1"
                    [max]="5000"
                    [rule]="validation.langdgransMax">
                  </rask-input-number>
                </div>
                <div class="d-flex flex-wrap">
                  <rask-input-number
                    aid="produktLangdintervalInput"
                    [disabled]="!isEditableRole"
                    class="langdinterval-input"
                    [(ngModel)]="produktLangdInterval"
                    [ngModelOptions]="{standalone: true}"
                    [label]="texts.inputLangdintervall"
                    [infoText]="texts.infoLangdintervall"
                    unit="cm">
                  </rask-input-number>
                  <rask-button
                    aid="skapaLangdmodulerButton"
                    class="skapa-langdmoduler-button"
                    [disabled]="skapaLangdmodulerDisabled"
                    color="secondary"
                    (click)="skapaLangdmoduler()">
                    {{texts.btnSkapaLangdmoduler}}
                  </rask-button>
                </div>
              </div>
              <!-- Längdmoduler -->
              <div class="col-7">
                <div class="row">
                  <div class="col-12 p-0 pb-3">
                    <rask-input-number
                      aid="nyLangdmodulInput"
                      [disabled]="!isEditableRole"
                      [(ngModel)]="nyLangdmodul"
                      [ngModelOptions]="{standalone: true}"
                      class="ps-0"
                      [label]="texts.inputLangmoduler"
                      unit="cm"
                      [min]="produktspecifikation.langdgransMin"
                      [max]="produktspecifikation.langdgransMax"
                      [rule]="validation.nyLangdmodul">
                    </rask-input-number>
                    <rask-checkbox
                      aid="setManuelltKapButton"
                      [disabled]="!isEditableRole"
                      [(ngModel)]="manuelltKap"
                      [ngModelOptions]="{standalone: true}"
                      class="pe-0"
                      [text]="texts.checkboxManuelltKap"
                      [checked]="false">
                    </rask-checkbox>
                    <rask-info>{{texts.infoManuelltKap}}</rask-info>
                    <rask-button
                      aid="laggTillLangdmodulButton"
                      [disabled]="addLangdmodulDisabled"
                      color="secondary"
                      (click)="laggTillLangdmodul()">
                      {{texts.btnLaggTillLangdModul}}
                    </rask-button>
                  </div>
                </div>
                <div class="row">
                  <rask-label class="p-0 langder-label" size="3" for="langdmodulInput">
                    {{texts.tagLangder}}
                  </rask-label>
                </div>
                <div class="row">
                  <ng-select
                    id="langdmodulInput"
                    class="col-8 p-0"
                    clearAllText="{{texts.tagClearAll}}"
                    [items]="[]"
                    [multiple]="true"
                    [isOpen]="false"
                    formControlName="produktLangdmoduler"
                    (change)="langdmodulChangeEvent($event)">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      @for (item of items; track item) {
                        <div class="ng-value">
                          <span class="ng-value-label">{{item.modul}}</span>
                          <rask-checkbox
                            aid="setManuelltKapButton-{{item.modul}}"
                            [disabled]="!isEditableRole"
                            class="langdmodulCheckbox"
                            [checked]="item.endastManuellaKap"
                            (checkedChange)="langdmodulCheckboxClicked($event, item)">
                          </rask-checkbox>
                          <span id="removeLangdmodulButton-{{item.modul}}" class="ng-value-icon"
                            (click)="clear(item)" aria-hidden="true"><i class="fal fa-times"></i></span>
                          </div>
                        }
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- Övermål för längder -->
            <div class="col-9">
              <div class="row pb-3">
                <div class="col-4">
                  <div class="d-flex">
                    <rask-input-number
                      aid="overmalMinInput"
                      class="overflow-label"
                      [label]="texts.inputOvermalMinMax"
                      [infoText]="texts.infoOvermal"
                      formControlName="overmalMin"
                      [step]="0.1"
                      unit="cm"
                      [min]="0.1"
                      [max]="50"
                      [rule]="validation.overmalMin">
                    </rask-input-number>
                    <span>-</span>
                    <rask-input-number
                      aid="overmalMaxInput"
                      class="overflow-label"
                      formControlName="overmalMax"
                      [step]="0.1"
                      unit="cm"
                      [min]="0.1"
                      [max]="50"
                      [rule]="validation.overmalMax">
                    </rask-input-number>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Basdata Energived och Övrigt -->
        @if (isEnergiOrOvrigt) {
          <div class="row m-3">
            <rask-input-number
              aid="fukthaltInput"
              [label]="texts.inputFukthalt"
              formControlName="fukthalt"
              unit="%"
              [min]="0"
              [max]="100"
              [rule]="validation.fukthalt">
            </rask-input-number>
            <rask-input-number
              aid="flisstorlekOnskadInput"
              [label]="texts.inputFlisstorlek"
              formControlName="flisstorlekOnskad"
              [step]="0.1"
              unit="cm"
              [min]="0.1"
              [max]="30"
              [rule]="validation.flisstorlekOnskad">
            </rask-input-number>
          </div>
        }
      </rask-container-block>
    </div>
  </form>
